import { useTranslation } from 'react-i18next';

const RenderBool = ({ children }) => {
  const { t } = useTranslation();

  return <div>{children === false ? t('no') : t('yes')}</div>;
};

export default RenderBool;
